import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { HIDE_POPUP_SIGNAL } from './popupContainer.constants';
import { getInitialStyle } from './popupContainer.style';
import { getPopupByID } from '../popups';

export default class PopupContainer extends Lightning.Component {
  static _template() {
    return getInitialStyle();
  }

  set content(value) {
    const data = _merge(getPopupByID(value.id), value.options);
    this._popupId = data.popupId;
    this.children = [this.stage.c({ ...data, ref: 'Content' })];
  }

  get popupId() {
    return this._popupId;
  }

  _focus() {
    this.alpha = 1;
  }

  _handleLeft() {
    return true;
  }

  _handleRight() {
    return true;
  }

  _handleBack() {
    this.signal(HIDE_POPUP_SIGNAL);

    return true;
  }

  _getFocused() {
    return this.tag('Content');
  }

  reset() {
    this._popupId = null;
    this.alpha = 0;
    this.children = [];
  }
}
